<template>
  <div class="page-header">
    <div class="logo">
      <img src="../../assets/images/parts-logo-wide.png" alt="">
    </div>
    <div class="quick-access">
      <div class="user-name">{{$auth.user().name}}</div>
      <el-dropdown trigger="click" @command="handleCommand" @visible-change="onDropdownVisibleChange">
        <span class="el-dropdown-link cursor-pointer">
          <img class="w-18" src="../../assets/icon/gear.png" alt="">
        </span>
        <el-dropdown-menu slot="dropdown" class="header-dropdown">
          <!-- マニュアルセクション（患者・薬剤師のみ表示） -->
          <template v-if="shouldShowManuals">
            <el-dropdown-item
              v-for="(manual, index) in manualLinks"
              :key="`manual-${index}`"
              :command="`manual-${index}`"
              class="manual-link"
            >
              <i class="el-icon-download"></i> {{ manual.menu_label }}
            </el-dropdown-item>

            <!-- セパレーター -->
            <el-dropdown-item v-if="manualLinks.length > 0" divided class="separator-item"></el-dropdown-item>
          </template>

          <!-- ログアウト・利用解除 -->
          <el-dropdown-item command="logout">ログアウト</el-dropdown-item>
          <el-dropdown-item v-if="isShowDeleteUserBtn" command="withdraw">利用解除</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import {USER_TYPE_PHARMACIST, USER_TYPE_PATIENT} from '@/const'
import DocumentationApi from '@/api/documentation'
import {apiErrorDialog} from '@/helpers'

export default {
  computed: {
    isShowDeleteUserBtn: function () {
      if (this.$auth.user().type === USER_TYPE_PHARMACIST) return false
      return true
    },
    shouldShowManuals: function () {
      const userType = this.$auth.user().type
      return userType === USER_TYPE_PATIENT || userType === USER_TYPE_PHARMACIST
    }
  },
  data () {
    return {
      USER_TYPE_PHARMACIST,
      USER_TYPE_PATIENT,
      manualLinks: [] // APIから取得したメニュー項目を格納
    }
  },
  methods: {
    // ドロップダウンメニューが開かれた時に呼ばれる
    async onDropdownVisibleChange (visible) {
      if (visible && this.shouldShowManuals) {
        await this.fetchManualList()
      }
    },
    // マニュアル一覧を取得
    async fetchManualList () {
      try {
        const userType = this.$auth.user().type
        const res = await DocumentationApi.getManualList(userType)

        // APIレスポンスの構造: { success: true, data: [...] }
        if (res.data && res.data.success && res.data.data) {
          // indexでソート（API側でソート済みだが念のため）
          this.manualLinks = res.data.data.sort((a, b) => a.index - b.index)
        } else {
          this.manualLinks = []
        }
      } catch (error) {
        // エラー時は空配列にして、メニューを非表示にする
        console.error('Failed to fetch manual list:', error)
        this.manualLinks = []
        // エラーダイアログは表示しない（メニューが表示されないだけ）
      }
    },
    async handleCommand (command) {
      if (command === 'logout') {
        this.logout()
      } else if (command === 'withdraw') {
        this.$router.push({name: 'account.delete'})
      } else if (command.startsWith('manual-')) {
        const index = parseInt(command.replace('manual-', ''))
        const manual = this.manualLinks[index]
        if (manual && manual.file_id) {
          await this.downloadManual(manual.file_id, manual.file_name)
        }
      }
    },
    async downloadManual (fileId, fileName) {
      try {
        const userType = this.$auth.user().type
        const res = await DocumentationApi.downloadFile(fileId, userType)

        // ダウンロード処理
        const blob = res.data
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url

        // ファイル名を設定（メニューAPIから取得した実ファイル名を使用）
        // fileNameが指定されていない場合は、Content-Dispositionヘッダーから取得を試みる
        let filename = fileName || 'manual.pdf'
        if (!fileName) {
          const contentDisposition = res.headers['content-disposition']
          if (contentDisposition) {
            const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/)
            if (filenameMatch && filenameMatch[1]) {
              filename = filenameMatch[1].replace(/['"]/g, '')
              // UTF-8エンコードされたファイル名のデコード
              if (filename.startsWith('UTF-8\'\'')) {
                filename = decodeURIComponent(filename.replace(/^UTF-8''/, ''))
              }
            }
          }
        }

        a.download = filename
        document.body.appendChild(a)
        a.click()
        window.URL.revokeObjectURL(url)
        document.body.removeChild(a)
      } catch (error) {
        apiErrorDialog(this, error)
      }
    },
    logout () {
      this.$loading.show({opacity: 1})
      this.$auth.logout()
      setTimeout(() => {
        window.location.reload()
      }, 1000)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/layouts/PageHeader.vue